import React from 'react';
import { SkeletonLoader } from '../util/SkeletonLoader';

export function NestedLoader({ size = 2 }) {
  return <SkeletonLoader size={5} />;
}

const RenderChildren = ({ node, onToggle, decorators, userSelections, depth, canFetch, searchInput ,handleSelectQuery}) => {
  const childrenNodes = Array.isArray(node.children) && node.children.length > 0 ? node.children : [];

  const { NestedLoader, NestedEmptyState } = decorators;

  if (node.loading) {
    return (
      <div style={{ marginLeft: `${(node.depth > 0 && node.depth || 1) * 30}px` }}>
        <SkeletonLoader size={5} />
      </div>
    );
  }

  if (node.childrenCount === 0 || (!canFetch && node.children.length === 0)) {
    return (
      <div style={{ marginLeft: `${(node.depth > 0 && node.depth || 1) * 30}px` }}>
        <NestedEmptyState node={node} />
      </div>
    );
  }

  if (!childrenNodes.length) {
    return (
      <div style={{ marginLeft: `${(node.depth > 0 && node.depth || 1) * 30}px` }}>
        <NestedEmptyState node={node} />
      </div>
    )
  }

  return childrenNodes.map((child) => {
    /* Passing onToggle => this.onToggle to each tree node to open and close */
    child.onToggle = (e) => {
      e?.preventDefault();
      e?.stopPropagation();
      onToggle(child, false);
    };
    /* Passing depth to make the node indent */
    child.depth = depth + 1;
    return (
      <RenderTree
        data={child}
        onToggle={onToggle}
        key={child.key}
        decorators={decorators}
        userSelections={userSelections}
        depth={child.depth}
        canFetch={canFetch}
        searchInput={searchInput}
        handleSelectQuery={handleSelectQuery}
      />
    );
  });
};

const RenderTree = (props) => {
  const { data, onToggle, decorators, userSelections, depth, canFetch, searchInput } = props;
  const { Header } = decorators;
  data.depth = depth

  const { headerStyle = {} } = userSelections

  return (
    <div key={data.uid}>
      <div style={data.type !== 'blank' ? headerStyle : {}} onClick={() => onToggle(data)}>
        <Header node={data} userSelections={userSelections} searchInput={searchInput}  handleSelectQuery={props.handleSelectQuery} />
      </div>
      {data.toggled ? (
        <RenderChildren
          node={data}
          onToggle={onToggle}
          decorators={decorators}
          userSelections={props.userSelections}
          depth={depth}
          canFetch={canFetch}
          searchInput={searchInput}
          handleSelectQuery={props.handleSelectQuery}

        />
      ) : null}
    </div>
  );
};

export default RenderTree;
